import { render } from "./ServiceTerms.vue?vue&type=template&id=147609ca&scoped=true&ts=true"
import script from "./ServiceTerms.vue?vue&type=script&lang=ts"
export * from "./ServiceTerms.vue?vue&type=script&lang=ts"

import "./ServiceTerms.vue?vue&type=style&index=0&id=147609ca&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147609ca"]])

export default __exports__